import { render } from "./ColorDropdownTreat.vue?vue&type=template&id=2aae01a2"
import script from "./ColorDropdownTreat.vue?vue&type=script&lang=js"
export * from "./ColorDropdownTreat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__